import { render, staticRenderFns } from "./TotalPower.vue?vue&type=template&id=968fd662&scoped=true&"
import script from "./TotalPower.vue?vue&type=script&lang=js&"
export * from "./TotalPower.vue?vue&type=script&lang=js&"
import style0 from "./TotalPower.vue?vue&type=style&index=0&id=968fd662&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "968fd662",
  null
  
)

export default component.exports